import styled, { css } from "styled-components";
import { theme } from "../theme/toyotaTheme";
import { EcoTagType } from "../../../../types/CommonTypes";

export const FuelTypeLabel = styled.span<{ type?: EcoTagType }>`
    font-family: ${theme.fonts.semiBold};
    font-size: 1.3rem;
    line-height: 2rem;
    text-transform: uppercase;
    ${({ type }) =>
        type &&
        css`
            color: ${type === EcoTagType.FuelCell ? theme.colors.fuelCell : theme.colors.hybrid};
        `};
`;

export default FuelTypeLabel;
